<template>
  <div class="modules">
    <div class="sidebar-wrap">
      <div
        @click="clickSliderIcon('comManagement')"
        class="item com-management"
      >
        <div class="fs12">企管</div>
      </div>
      <div @click="clickSliderIcon('user')" class="item user">
        <div class="fs12">账户</div>
      </div>
      <div @click="clickSliderIcon('info')" class="item info">
        <div class="fs12 cl999999">消息 {{ $imSDKStore&&($imSDKStore.totalUnReadNum == 0? '' : $imSDKStore.totalUnReadNum > 99 ? '99+' : $imSDKStore.totalUnReadNum)}}
          <el-badge v-if="$imSDKStore&&$imSDKStore.totalUnReadNum > 0" style="position:absolute;top: -24px;right: 3px;" is-dot class="item"></el-badge>
        </div>
        <!-- <div class="fs12 cl999999 diff">
          消息
          <el-badge
            class="unread-badge"
            :value="
              $imSDKStore &&
              ($imSDKStore.totalUnReadNum == 0
                ? ''
                : $imSDKStore.totalUnReadNum > 99
                ? '99+'
                : $imSDKStore.totalUnReadNum)
            "
            :hidden="!$imSDKStore"
            :max="99"
          ></el-badge>
        </div> -->
      </div>
      <div @click="clickSliderIcon('apply')" class="item apply">
        <div class="fs12">申请</div>
      </div>

      <div @click="clickSliderIcon('invite')" class="item invite">
        <div class="fs12">邀请</div>
      </div>
      <div @click="clickSliderIcon('meeting')" class="item meeting">
        <div class="fs12">会议</div>
      </div>
      <div @click="_ysfOpen" class="item service">
        <div class="fs12">客服
            <zj-customer
                    :env="customerEnv"
                    :imUser="{token: this.$store.state.user.imToken, accountId: this.$store.state.user.imAccount}"
                    ref="customerRef"
            ></zj-customer>
        </div>
      </div>
      <div @click="clickOpinion" class="item ask">
        <div class="fs12">反馈</div>
      </div>
      <div @click="clickSliderIcon('enquiry')" class="item enquiry">
        <div class="fs12">询价</div>
      </div>

      <div @click="clickSliderIcon('shop')" class="item shop">
        <div class="fs12">采购单</div>
      </div>
      <div @click="scrollTop" class="item top">
        <div class="text-centers">回顶部</div>
      </div>
    </div>

    <!--    问题反馈弹框-->
    <el-dialog
      :close-on-click-modal="false"
      title="问题反馈"
      @close="Mixin_dialogClose('opinion', 'isShowOpinionDialog')"
      :visible.sync="isShowOpinionDialog"
      width="1000px"
    >
      <div class="opinion-wrap">
        <div>
          如果你对本网站有什么意见或者建议，请在此提交，我们的客服核实后会跟你联系.
        </div>
        <br />
        <el-form
          ref="opinion"
          :model="opinion"
          :rules="opinionRules"
          label-width="100px"
        >
          <el-form-item label="所属板块：" prop="plate">
            <el-select
              class="wd100"
              v-model="opinion.plate"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in plateOptions"
                :key="index"
                :value="item.no"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="意见内容：" prop="content">
            <el-input
              v-model="opinion.content"
              maxlength="500"
              placeholder="请输入您的具体意见或建议内容,500字以内"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传图片：" prop="imgList">
            <el-upload
              v-if="isShowOpinionDialog"
              :on-remove="handleRemove"
              :before-upload="handleUpload"
              :on-success="handleSuccess"
              :action="action"
              list-type="picture-card"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div>
              {{ fileList.length }}/5(最多可上传5张图片，支持：jpg/jpeg/png格式)
            </div>
          </el-form-item>
          <el-form-item label="联系人：" prop="user">
            <el-input
              maxlength="20"
              placeholder="请输入"
              v-model="opinion.user"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="phone">
            <el-input
              maxlength="11"
              placeholder="请输入"
              v-model="opinion.phone"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="mt10 dis-fl ju-ct">
          <el-button
            class="pd20"
            :loading="buttonLoading"
            type="primary"
            @click="submitOpinionBtn('opinion')"
          >
            提交
          </el-button>
          <el-button class="pd20" @click="isShowOpinionDialog = false">
            取消
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 发布询价弹窗 -->
    <SaveInquiryPrice
      v-if="enquiryDetails && enquiryDetails.type === 1"
      :formLoading="formLoading"
      :enquiryDetails="enquiryDetails"
      @closeInquiryPriceDialog="closeInquiryPriceDialog"
    ></SaveInquiryPrice>
    <!--邀请加盟-->

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>您需要先进行企业认证</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">暂不认证</el-button>
        <el-button type="primary" @click="goToAuthPage()">去认证</el-button>
      </span>
    </el-dialog>
    <!-- 会议 -->
    <!-- 申请邀请弹窗 -->
    <JoinDialog :type="joinType" :isShow="showJoinDialog"></JoinDialog>
    <!-- 交流 -->
    <ChatIm></ChatIm>
    <!-- 会议 -->
    <Meeting :openDia="openDia" @closeMeeting="closeMeeting"></Meeting>
    <!-- 反馈 -->
    <ZjunFeedback
      v-if="showModal"
      :userInfo="userInfo"
      :showModal="showModal"
      @close="showModal = false"
      :apiList="apiList"
      @contactCustomer="contactCustomer"
      :uploadApiconf="uploadApiconf"
      :environment="customerenv"
    ></ZjunFeedback>
  </div>
</template>

<script>
import { apiHome } from "@/api/apiHome"
import Vue from 'vue'
import store from '@/store'
import ZjCustomer from 'zj-plugin-chat-customer'
Vue.use(ZjCustomer, { store })
import {ZjunFooter, ZjunFeedback} from 'zjkjui' 
import http from '@/http'
Vue.use(ZjunFooter)
Vue.use(ZjunFeedback, {axios: http})
export default {
  name: "modules",
  data() {
    let validImgList = (rule, value, callback) => {
      if (!this.fileList.length) {
        callback(new Error("请上传图片"))
      } else {
        callback()
      }
    }
    let validPhone = (rule, value, callback) => {
      const reg = /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/
      if (!value) {
        callback(new Error("请输入联系电话"))
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号码格式"))
      } else {
        callback()
      }
    }
    return {
      customerEnv: process.env.VUE_APP_NAME,
      //0-邀请 1-申请
      joinType:0,
      //申请邀请弹窗
      showJoinDialog:false,
      // 会议
      showOperation: false,
      // IM
      isShowIm: false,
      imAccount: "",
      imToken: "",
      random: 0,
      // 询价
      enquiryDetails: {},
      formLoading: false,
      // 邀请加盟弹窗
      dialogVisible: false,
      // 按钮状态
      buttonLoading: false,

      timer: null,
      // 上传图片地址
      action: this.$store.state.upload,
      // 文件列表
      fileList: [],
      // isShowOpinionDialog: false,
      // 显示意见反馈弹框
      showModal: false,
      // 板块数组
      plateOptions: [],
      // 意见obj
      opinion: {
        plate: "",
        content: "",
        user: "",
        phone: ""
      },
      opinionRules: {
        plate: [
          {
            required: true,
            message: "请选择所属板块",
            trigger: "change"
          }
        ],
        content: [
          {
            required: true,
            message: "请输入意见内容",
            trigger: "blur"
          }
        ],
        imgList: [
          {
            required: true,
            validator: validImgList,
            trigger: "blur"
          }
        ],
        user: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            validator: validPhone,
            trigger: "blur"
          }
        ]
      },
      apiList: {
        feedBackTypeList:`${process.env.VUE_APP_GGBBASEAPI}/sgb-im/message/get/feedback/list`,
        saveFeedbackRecord:`${process.env.VUE_APP_GGBBASEAPI}/sgb-im/message/save/feedbackRecord`
      },
      uploadApiconf: {
        getUploadToken:`${process.env.VUE_APP_GGBBASEAPI}/mg-oss-service/file/getObsToken`,
        getAssetDetail:`${process.env.VUE_APP_GGBBASEAPI}/mg-oss-service/file/getAssetDetail`,
        getAssetIdByTemplateId:`${process.env.VUE_APP_GGBBASEAPI}/mg-oss-service/file/getAssetIdByTemplateId`
      },
      loginUserInfo: {},
      // 控制会议的弹框
      openDia: false
    }
  },
  computed: {
    userInfo: function() {
      return this.$store.state.user
    },
    openMeeting() {
      return this.$store.state.openMeeting
    },
    authUser() {
      return this.$store.state.authUser
    },
    // 显示聊天弹框
    showImChat() {
      return this.$store.state.showImChat
    }
  },
  watch: {
    userInfo: {
      handler: function(newVal) {
        if (newVal) {
          this.loginUserInfo = newVal
          this.opinion.user = newVal.realName || ""
          this.opinion.phone = newVal.telPhone || ""
        }
      },
      immediate: true
    }
  },
  components: {
    ChatIm: () => import("@/components/chatIm/chatIm"), // 聊天
    Meeting: () => import("@/components/meeting/meeting"), // 会议
    SaveInquiryPrice: () => import("@/views/Home/InquiryPrice/SaveInquiryPrice")
  },
  mounted() {
    this.$nextTick(() => {
      this.getPlate()
    })
  },
  methods: {
    // 跳认证页面
    goToAuthPage() {
      window.location.href =
        process.env.VUE_APP_PERSONURL + "/authenticationManagement"
    },

    loginIndex() {
      let data = {
        callBack: function() {
          this.$store.dispatch("setUser")
        }.bind(this)
      }
      this.$_login(data)
    },
    // 滑动到顶部
    scrollTop() {
      // 加入定时器让他又快到慢滚动到顶部
      let timer = setInterval(() => {
        // 获取当前scrollTop的高度位置（兼容ie和chrom浏览器）
        let oTop = document.documentElement.scrollTop || document.body.scrollTop
        // 设置速度由快到慢
        let ispeed = Math.floor(-oTop / 3)
        document.documentElement.scrollTop = document.body.scrollTop =
          oTop + ispeed
        if (oTop === 0) {
          clearInterval(timer)
        }
      }, 30)
    },
    // 点击侧边栏
    async clickSliderIcon(type) {
      const URL = process.env.VUE_APP_PERSONURL
      //
      const URL1 = process.env.VUE_APP_MATERIALSURL
      // const zhaocaiUrl = process.env.VUE_APP_ZHAOCAI
      const url_qiguanbang = process.env.VUE_APP_QIGUANBANG
      if (!this.$store.state.loginType) {
        this.loginIndex()
        return
      }
        const { data: res } = await apiHome.getIdentifiers();
				const arr = res.result.identifiers
				const ApplyMemberC = arr.some(i=>i==='ApplyMemberC')
				const InviteJoinListC = arr.some(i=>i==='InviteJoinListC')

      // const isRealName = this.$store.state.user.personalAuth
      const isCompany = this.$store.state.user.type === 1//企业
      const isTeam = this.$store.state.user.type === 2//团队
      const isPersonal = this.$store.state.user.type === 0//个人
      const isRelevance =
        (this.$store.state.user.type === 0||this.$store.state.user.type === 1) &&
        this.$store.state.user.relevance
      if (type === "info") {
        let obj = {
          imAccount: this.$store.state.user.imAccount,
          imToken: this.$store.state.user.imToken
        }
        if (obj.imAccount && obj.imToken) {
          this.$store.commit("setChatStatus", true)
        } else {
          this.$message.error("打开消息失败")
        }
      } else if (type === "comManagement") {
        // 企管帮
        /*if (!this.$store.state.loginType) {
          window.open(url_qiguanbang)
        } else {
          let clientId = cookie.cookieRead("clientId")
          apiHome.saveUserTokenToRedis().then(res => {
            window.open(url_qiguanbang + "?clientId=" + clientId)
          })
        }*/
        window.open(`${url_qiguanbang}/index?platform=jyb`);
      } else if (type === "user") {
        window.open(URL + "/basicInfoP")
      } else if (type === "message") {
        window.open(URL + "/myMessage")
      } else if (type === "backlog" || type === "businessOpt") {
        window.open(URL)
      } else if (type === "invite") {
        if (isCompany ||isPersonal|| isRelevance) {
          if (InviteJoinListC) {
              this.joinType = 0
              this.showJoinDialog = true
						}
            else{
							this.$message.error('没有权限操作，请找企业管理员分配权限');
						}
        } else if(isTeam) {
          this.$message.error('请切换至企业或个人身份');
        }
      }
      // else if (type === "meeting") {
      //   let obj = {
      //     imAccount: this.$store.state.user.imAccount,
      //     imToken: this.$store.state.user.imToken
      //   }
      //   if (obj.imAccount && obj.imToken) {
      //     this.$store.commit("setImAccount", obj)
      //   }
      //   this.openDia = true
      // }
       else if (type === "enquiry") {
        this.toEnquiry()
      } else if (type === "shop") {
        if (isCompany || isRelevance) {
          window.open(URL1 + "/busone")
        } else {
          this.dialogVisible = true
        }
      } else if (type === "apply") {
        if (isCompany || isPersonal|| isRelevance) {
          if (ApplyMemberC) {
              this.joinType = 1
              this.showJoinDialog = true
						}
            else{
							this.$message.error('没有权限操作，请找企业管理员分配权限');
						}
        } else if(isTeam) {
          this.$message.error('请切换至企业或个人身份');
        }
      }
    },
    closeMeeting() {
      this.openDia = false
    },
    // 点击客服
    _ysfOpen() {
      if (!this.$store.state.loginType) {
        this.loginIndex()
        return
      }
      this.$kfClient({
        imUser: { accountId: this.$store.state.user.imAccount, token: this.$store.state.user.imToken },
        env: this.customerEnv,    // 当前环境，请使用项目中类似VUE_APP_NAME的变量传入，以区分不同环境
        onClose: function () {
          // 关闭回调
        }
      })
      // window.ysf.open()
      // this.$refs.customerRef.open()
    },
    // 关闭询价弹窗
    closeInquiryPriceDialog() {
      this.formLoading = false
      this.enquiryDetails = {}
    },
    // 询价弹窗
    toEnquiry() {
      if (!this.$store.state.token) {
        this.loginAuth()
        return
      }
      if (
        this.userInfo.userRole ||
        this.userInfo.personalAuth ||
        (this.userInfo.userRole === 0 && this.userInfo.relevance)
      ) {
        if (this.authUser.identifiers.indexOf("SaveInquiryPrice") === -1) {
          this.$message({
            message: "此功能无权限, 请联系管理员分配权限",
            type: "warning"
          })
          return
        }
        this.$set(this.enquiryDetails, "type", 1)

        this.formLoading = true
      } else {
        this.dialogVisible = true
      }
    },

    // 点击问题图标
    clickOpinion() {
      // this.isShowOpinionDialog = true
      // this.opinion.user = this.loginUserInfo.realName || ""
      // this.opinion.phone = this.loginUserInfo.telPhone || ""
      if (!this.$store.state.loginType) {
        this.loginIndex()
        return
      }
      this.showModal = true;

    },
    // 图片上传限制
    handleUpload(file, comeType) {
      if (this.fileList.length > 5) {
        this.$_toast({
          type: "error",
          msg: "最多只能上传5张照片."
        })
        return false
      }
      // 图片格式校验
      let testImg = /^image\/(png|jpg|jpeg)$/.test(file.type)
      // 图片大小校验
      let isLt4M = file.size / 1024 / 1024 <= 10
      if (!testImg) {
        this.$_toast({
          type: "error",
          msg: "上传图片格式不对! 仅支持.png .jpg .jpeg的格式文件."
        })
        return false
      }
      if (!isLt4M) {
        this.$_toast({ type: "error", msg: "上传图片大小不能超过 10M!" })
        return false
      }
      return testImg && isLt4M
    },
    // 图片上传成功
    handleSuccess(res, file, fileList) {
      if (res.code === 200) {
        this.fileList = fileList
        this.$refs.opinion.validateField("imgList")
      }
    },
    // 删除照片
    handleRemove(file, fileList) {
      this.fileList = fileList
      this.$refs.opinion.validateField("imgList")
    },
    // 获取意见反馈所属板块
    getPlate() {
      apiHome.getPlate().then(res => {
        if (res.data.code === 200) {
          this.plateOptions = res.data.data
        }
      })
    },
    // 提交意见
    submitOpinionBtn(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.buttonLoading = true
          let params = {}
          params.contact = this.opinion.user
          params.contactNumber = this.opinion.phone
          params.content = this.opinion.content
          params.type = this.opinion.plate
          let arr = []
          this.fileList.forEach(item => {
            arr.push(item.response.data)
          })
          params.images = arr.join(",")
          if (this.loginUserInfo.userRole) {
            params.company = this.loginUserInfo.companyNo
          }
          apiHome.siteFeedback(params).then(res => {
            this.buttonLoading = false
            if (res.data.code === 200) {
              this.$message.success("问题反馈成功")
              this.isShowOpinionDialog = false
            }
          })
        }
      })
    },
    contactCustomer() {
      this.$kfClient({
        imUser: { accountId: this.$store.state.user.imAccount, token: this.$store.state.user.imToken },
        env: this.customerEnv, // 当前环境，请使用项目中类似VUE_APP_NAME的变量传入，以区分不同环境
        onClose: function() {
          // 关闭回调
        }
      });
    },
  }
}
</script>
<style lang="scss">
.cl999999 {
  color: #999999;
}
.ShowTosatDialog {
  background: rgba(0, 0, 0, 0.4);
  .el-dialog__header {
    padding: 0 !important;
    border-bottom: none !important;
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
      position: relative;
      top: -17px;
      right: -17px;
    }
  }
  .el-dialog__body {
    padding: 20px 0;
    .opinion-wrapLeft {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      // padding: 0 5%;
      .itemBox {
        width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
        .item {
          padding: 15px;
          background: rgba(0, 0, 0, 0.6);
          border-radius: 8px;
          img {
            width: 110px;
            height: 110px;
            display: inline-block;
          }
          .textBox {
            text-align: center;
            width: 100%;
            font-size: 16px;
            font-weight: 400;
            color: rgba(245, 245, 245, 1);
          }
        }
        &:nth-child(1) {
          margin-bottom: 30px;
        }
        &:nth-child(2) {
          margin-bottom: 30px;
        }
        &:nth-child(3) {
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.ShowTosatDialog {
  background: rgba(0, 0, 0, 0.4);
  .el-dialog__header {
    padding: 0 !important;
    border-bottom: none !important;
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
      position: relative;
      top: -17px;
      right: -17px;
    }
  }
  .el-dialog__body {
    padding: 20px 0;
    .opinion-wrapLeft {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      // padding: 0 5%;
      .itemBox {
        width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
        .item {
          padding: 15px;
          background: rgba(0, 0, 0, 0.6);
          border-radius: 8px;
          img {
            width: 110px;
            height: 110px;
            display: inline-block;
          }
          .textBox {
            text-align: center;
            width: 100%;
            font-size: 16px;
            font-weight: 400;
            color: rgba(245, 245, 245, 1);
          }
        }
        &:nth-child(1) {
          margin-bottom: 30px;
        }
        &:nth-child(2) {
          margin-bottom: 30px;
        }
        &:nth-child(3) {
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>
<style scoped>
#ImContent {
  position: fixed;
  top: 0;
  left: calc((100vw - 1200px) / 2);
  margin-top: calc((100vh - 70vh) / 2);
  height: calc(70vh);
  /*margin-left: calc((100vw - 1200px)/2) ;*/
  z-index: 999;
  background-color: #ffffff;
  border: 1px solid #2e90fe;
  width: 1200px;
}
</style>
<style lang="scss" rel="stylesheet/scss" scoped>
.el-select {
  width: 235px;
}
.meeting-box {
  padding-top: 20px;
  text-align: center;
  img {
    cursor: pointer;
  }
}
.change-data {
  line-height: 34px;
  color: #3a8ee6;
  font-size: 14px;
  text-align: center;
  border-top: 1px solid #ebeef5;
  cursor: pointer;
}
.modules {
  // width: 1200px;
  // margin: 0 auto;
  font-size: 0;
}

.bg {
  /*padding: 0 15px;*/
  background-color: #ffffff;
}
.bg1 {
  background-color: #fcf5e2;
}
.bg2 {
  background-color: #fff9ea;
}
// .bg3 {
//   /*background-color: #e8fefd;*/
// }
.bg4 {
  background-color: #eaf4fe;
}
.sidebar-wrap-left {
  position: fixed;
  left: 50%;
  left: calc(50% - 680px);
  left: 0px;
  top: calc(50% + 60px);
  width: 121px;
  z-index: 3;

  & > .item {
    height: 81px;
    cursor: pointer;
  }
}
.sidebar-wrap {
  position: fixed;
  // left:calc(100vw - (100vw - 1220px) / 2);
  left: calc((100vw - 1200px - 17px) / 2 + 1200px + 3px);
  margin-left: 20px;
  background-color: #999;
  width: 60px;
  top: 200px;
  z-index: 999;
  // border: 1px solid #e4e7ed;
  top: 200px;
  & > .item {
    height: 60px;
    width: 60px;
    cursor: pointer;
    border-bottom: 1px solid #e4e7ed;
    font-size: 12px;
    div {
      text-align: center;
      padding-top: 36px;
      color: #fff;
    }
  }

  & > .item:last-child {
    border-bottom: none;
  }
  .com-management {
    background: url("../../../assets/sidebar/qiguan.png") center 7px no-repeat;
    background-size: 30px 30px;
    background-color: #e1251b;
  }
  .user {
    background: url("../../../assets/sidebar/zhanghu.png") center 7px no-repeat;
    background-size: 30px 30px;
    &:hover {
      background-color: #b79255;
    }
  }

  .info {
    position: relative;
    background: url("../../../assets/sidebar/xiaoxi.png") center 7px no-repeat;
    background-size:30px 30px;
    &:hover {
      background-color: #b79255;
    }
    .unread-badge {
    position: absolute;
    top: -34px;
  }
  .unread-badge /deep/.el-badge__content {
    height: 19px;
    line-height: 16px;
    &.is-fixed {
      right: 8px;
      top: -25px;
    }
  }
  }


  .apply {
    background: url("../../../assets/sidebar/shenqing.png") center 7px no-repeat;
    background-size:30px 30px;
    &:hover {
      background-color: #b79255;
    }
  }

  .invite {
    background: url("../../../assets/sidebar/yaoqing.png") center 7px no-repeat;
    background-size:30px 30px;
    &:hover {
      background-color: #b79255;
    }
  }

  .meeting {
    background: url("../../../assets/sidebar/huiyi.png") center 7px no-repeat;
    background-size:30px 30px;
    &:hover {
      background-color: #b79255;
    }
  }

  .service {
    background: url("../../../assets/sidebar/kefu.png") center 7px no-repeat;
    background-size:30px 30px;
    &:hover {
      background-color: #b79255;
    }
  }

  .ask {
    background: url("../../../assets/sidebar/fankui.png") center 7px no-repeat;
    background-size:30px 30px;
    &:hover {
      background-color: #b79255;
    }
  }

  .enquiry {
    background: url("../../../assets/sidebar/xunjia.png") center 7px no-repeat;
    background-size:30px 30px;
    &:hover {
      background-color: #b79255;
    }
  }

  .shop {
    background: url("../../../assets/sidebar/caigoudan.png") center 7px no-repeat;
    background-size:30px 30px;
    &:hover {
      background-color: #b79255;
    }
  }

  .top {
    background: url("../../../assets/sidebar/tops.png") 13px 12px no-repeat;
    background-size:32px 20px;
    background-color: #ccc;
    .text-centers{
      text-align: center;
      padding-top: 33px;
      font-size: 13px;
  }
  }
}
@media screen and (max-height: 900px) {
  .sidebar-wrap {
    width: 52px;
    & > .item {
      height: 52px;
      width: 52px;
      > div {
        padding-top: 30px;
      }
    }
    .com-management {
      background: url("../../../assets/sidebar/qiguan.png") center 5px no-repeat;
      background-size: 25px 25px;
      background-color: #e1251b;
    }
    .user {
      background: url("../../../assets/sidebar/zhanghu.png") center 5px no-repeat;
      background-size: 25px 25px;
      &:hover {
        background-color: #b79255;
      }
    }
    .info {
      background: url("../../../assets/sidebar/xiaoxi.png") center 5px no-repeat;
      background-size: 25px 25px;
      &:hover {
        background-color: #b79255;
      }
    }
    .apply {
      background: url("../../../assets/sidebar/shenqing.png") center 5px no-repeat;
      background-size: 25px 25px;
      &:hover {
        background-color: #b79255;
      }
    }
    .invite {
      background: url("../../../assets/sidebar/yaoqing.png") center 5px no-repeat;
      background-size: 25px 25px;
      &:hover {
        background-color: #b79255;
      }
    }
    .meeting {
      background: url("../../../assets/sidebar/huiyi.png") center 5px no-repeat;
      background-size: 25px 25px;
      &:hover {
        background-color: #b79255;
      }
    }
    .service {
      background: url("../../../assets/sidebar/kefu.png") center 5px no-repeat;
      background-size: 25px 25px;
      &:hover {
        background-color: #b79255;
      }
    }
    .ask {
      background: url("../../../assets/sidebar/fankui.png") center 5px no-repeat;
      background-size: 25px 25px;
      &:hover {
        background-color: #b79255;
      }
    }

    .enquiry {
      background: url("../../../assets/sidebar/xunjia.png") center 5px no-repeat;
      background-size: 25px 25px;
      &:hover {
        background-color: #b79255;
      }
    }
    .shop {
      background: url("../../../assets/sidebar/caigoudan.png") center 5px no-repeat;
      background-size: 25px 25px;
      &:hover {
        background-color: #b79255;
      }
    }
    .top {
    background: url("../../../assets/sidebar/tops.png") 10px 6px no-repeat;
    background-size:32px 20px;
    background-color: #ccc;
    .text-centers{
      text-align: center;
      padding-top: 28px;
      font-size: 13px;
  }
  }
  }
}
.opinion-wrap {
  padding-left: 40px;
  padding-right: 140px;
}
</style>
